// extracted by mini-css-extract-plugin
export default {"large":"Pfirst_large__y2Paf","normal":"Pfirst_normal__mwXla","Pfirst":"Pfirst_Pfirst__uIDae","Pfirst_en":"Pfirst_Pfirst_en__Vom4A","text":"Pfirst_text__mOUMo"};